import DashboardContext from "@/contexts/DashboardContext";
import { useDigitalTwins } from "@/hooks/useDigitalTwins";
import { useContext, useEffect } from "react";
import DigitalTwinsContent from "./DigitalTwinsContent";
import { useDigitalTwinsContext } from "@/contexts/DigitalTwinsContext";

function DigitalTwinsContainer() {
    const { value: dashboardContext } = useContext(DashboardContext);
    const { digitalTwinsData, loading, fetchDigitalTwinsData } = useDigitalTwins();
    const { selectedDigitalTwinId, setSelectedDigitalTwinId, setSelectedDigitalTwinsData } = useDigitalTwinsContext();

    // Fetch digital twins data when location changes
    useEffect(() => {
        if (dashboardContext.selectedLocation) {
            fetchDigitalTwinsData(dashboardContext.selectedLocation.toString());
        }
    }, [dashboardContext.selectedLocation]);

    // Sync digital twins data to context and auto-select first digital twin
    useEffect(() => {
        if (digitalTwinsData && digitalTwinsData.length > 0) {
            setSelectedDigitalTwinsData(digitalTwinsData);
            
            // Auto-select first digital twin when location changes
            const firstDT = digitalTwinsData[0];
            setSelectedDigitalTwinId(firstDT.inpId.toString());
        }
    }, [digitalTwinsData, setSelectedDigitalTwinsData, setSelectedDigitalTwinId]);

    const handleSelectDigitalTwin = (id: string) => {
        setSelectedDigitalTwinId(id);
    };

    return (
        <DigitalTwinsContent
            loading={loading}
            digitalTwinsData={digitalTwinsData}
            selectedDigitalTwinId={selectedDigitalTwinId}
            onSelectDigitalTwin={handleSelectDigitalTwin}
        />
    );
}

export default DigitalTwinsContainer;
